import { httpClient } from '@/services/http/httpClient'
import { getQueryParams, type QueryParams } from '@/utils/queryParams'

type Pagination = {
  total: number
  page: number
  pages: number
  limit: number
}

type GetPortfolioColumn = {
  id: string
  title: string
  position: number
  portfolioId: string
  tennantId: string
  createdAt: string
  updatedAt: string
}

type GetPortfolioColumnsResponse = {
  portfolioColumns: GetPortfolioColumn[]
  paginate: Pagination
}

export type PortfolioColumn = {
  value: string
  label: string
  sequence: number
}

type PortfolioColumnsReturn = {
  columns: PortfolioColumn[]
  pagination: Pagination
}

export async function getPortfolioColumns({
  query,
}: {
  query: QueryParams
}): Promise<PortfolioColumnsReturn> {
  const queryParams = getQueryParams(query)

  const { data } = await httpClient.get<GetPortfolioColumnsResponse>(
    `/projects/portfolio-columns/${query.portfolioId}?${queryParams}`,
  )

  return {
    columns: data.portfolioColumns.map((column) => ({
      value: column.id,
      label: column.title,
      sequence: column.position,
    })),
    pagination: data.paginate,
  }
}
